angular.module('impactx.cscontract').controller('CSCCommonRelationCtrl', [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    '$routeParams',
    'TranslationService',
    'ToolbarService',
    '$config',
    CSCCommonRelationCtrl
]);

function CSCCommonRelationCtrl($scope, dataGen, BackService, ToastService, $routeParams, TranslationService, ToolbarService, $config) {
    var ctrl = this;

    $scope.tinymceOptions = $config.tinymceOptions;

    ctrl.getData = function (comChange, comId) {
        var paramObj = {
            comId: comId,
            cscCommonId: $routeParams.csccommonId,
            comChange: comChange
        };
        dataGen.getData($scope, paramObj, '/cscontract/basiccontract/viewrelation').then(function () {
            defineButtons();

            // add the watcher only once after the data was fetched to prevent unnecessary request to backend
            if (!comChange) {
                $scope.$watch(function () {
                    return impactX.isDefined($scope, 'data.buyerCom.selected.id')
                }, function (newVal, oldVal) {
                    if ((newVal || (newVal === 0 && oldVal > 0)) && newVal !== oldVal) {
                        ctrl.getData(true, newVal);
                    }
                });
            }
        });
    };

    ctrl.save = function () {
        var paramObj = {
            data: $scope.data
        };
        return dataGen.postAsForm({}, paramObj, '/cscontract/basiccontract/saverelation').then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        });
    };

    ctrl.delete = function () {
        var paramObj = {
            cscId: $scope.data.cscId,
            cscCommonId: $routeParams.csccommonId
        };
        return dataGen.postAsForm({}, paramObj, '/cscontract/basiccontract/deleterelation').then(function () {
            BackService.back();
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        });
    };

    ctrl.canDelete = function () {
        return !!$scope.data.cscId
    }

    ctrl.getData(false, $routeParams.id);

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get('save'),
                type: 'validation',
                action: ctrl.save,
                params: {form: $scope.dialogData}
            },
            {
                label: TranslationService.get('delete'),
                type: 'dialogAction',
                action: ctrl.delete,
                condition: ctrl.canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}